const a = (t) => t.tagName === "SELECT" && !t.disabled || !!t.name && !t.disabled && t.type !== "file" && t.type !== "reset" && t.type !== "submit" && t.type !== "button";
export {
  a as isValidFormInputElement
};
